import api from '@/api';
import { useAuthStore } from '@/stores/auth';

class PermissionService {
  async fetchPermissionList() {
    try {
      const response = await api.get(`/auth/me/permissions`);    
      if (response.status === 200) {  
        sessionStorage.setItem('permissions', JSON.stringify(response.data));
        return response.data;
      }
      return false;
    } catch (error) {      
      console.error('Permission fetch error:', error);
      return false;
    }
  }

  async hasPermission(permission: string) { 
    const authStore = useAuthStore();
    if (!authStore.isSubuser()) {
      return true;
    }

    let permissions = sessionStorage.getItem('permissions');
    if (!permissions) {
      const fetchedPermissions = await this.fetchPermissionList();
      if (!fetchedPermissions) {
        return false;
      }
      permissions = JSON.stringify(fetchedPermissions);
    }

    try {
      const permissionList = JSON.parse(permissions);
      return permissionList.includes(permission);
    } catch (e) {
      console.error('Permission parse error:', e);
      return false;
    }
  }
}

export default new PermissionService();